import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface BackLinkProps {
  to?: string;
}

export const BackLink = ({ to = '/onboarding' }: BackLinkProps) => {
  const navigate = useNavigate();

  return (
    <Button
      startIcon={<ChevronLeftRoundedIcon />}
      onClick={() => navigate(to)}
      sx={{ alignSelf: 'flex-start', fontWeight: 700, px: 0 }}
    >
      VOLTAR
    </Button>
  );
};
